module.exports = __webpack_public_path__ + "static/media/club_messages.da933032.svg";